import { ComponentRoute } from '@/classes'

const EmailSmsLogRoutes = {
  EmailSmsLogListView: new ComponentRoute('/emailsmslogs', 'EmailSmsLogListView'),
  EmailSmsLogView: new ComponentRoute('/emailsmslogs/:id', 'EmailSmsLogView'),
  EmailSmsLogDetail: new ComponentRoute('/emailsmslogs/:id', 'EmailSmsLogDetail')
}

export default EmailSmsLogRoutes
